module.exports = __webpack_public_path__ + "static/assets/f4efdb43577b9f9f482ce10561fe1471.otf";